module.exports = __webpack_public_path__ + "img/regular_on.42b08a77.svg";